import { buildDocumentCitationLabel } from "@repo/shared";
import type { DocumentEvidencePresentation } from "@repo/shared/document-evidence-link";

export type AvailableDocumentEvidencePresentation = Extract<
  DocumentEvidencePresentation,
  { status: "available" }
>;

/**
 * The visible text of a diff-marked evidence chip.
 *
 * Live citations are compact markers: the document name is only the accessible name, and a
 * run of chips collapses to one marker whose popover names each place. A redline cannot do
 * that — every citation a revision added or removed must stay individually visible — so its
 * chips are the one place the label is prose, and a revision routinely cites one document in
 * two places. Two chips both reading "Brief v1.2" side by side look like a duplicate
 * (LAT-999). The redline therefore reuses the plain-prose citation label the backend hands
 * Claudia, `buildDocumentCitationLabel`: the document name qualified by the deepest heading
 * and the page, so each chip says where it points. Nothing new is stored — the qualification
 * is derived from the live presentation, the same source the popover reads.
 */
export function formatDiffEvidenceChipLabel(
  presentation: AvailableDocumentEvidencePresentation
): string {
  return buildDocumentCitationLabel({
    documentName: presentation.documentName,
    headingPath: presentation.headingPath,
    pageStart: presentation.pageStart,
    pageEnd: presentation.pageEnd,
  });
}
